import { render, staticRenderFns } from "./service-list-item.vue?vue&type=template&id=b7b3aa58"
import script from "./service-list-item.vue?vue&type=script&lang=js"
export * from "./service-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports